import styled from 'styled-components';

export const VideoWrapper = styled.div<{
  isFullScreen?: boolean;
}>`
  position: relative;
  width: 100%;
  height: fit-content;
  max-height: 450px;
  top: 40%;
  transform: translateY(-50%);

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 453px;
    max-height: 370px;
    max-width: 751px;
    top: ${({ isFullScreen }) => (isFullScreen ? '50%' : 'unset')};
    transform: ${({ isFullScreen }) =>
      isFullScreen ? 'translateY(-50%)' : 'unset'};

    box-sizing: border-box;
    margin-right: auto;
    margin-left: auto;

    & video {
      object-fit: fill;
      max-height: 370px;
    }
  }
`;

export const VideoThumbnailWrapper = styled.div`
  position: relative;
  width: auto;
  height: 61px;
  overflow: hidden;
  .ytp-button:not([aria-disabled='true']):not([disabled]):not(
      [aria-hidden='true']
    ) {
    width: 36px !important;
    height: 36px !important;
  }

  & video {
    object-fit: cover;
  }
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

export const VideoWrapperMobile = styled.div`
  position: relative;
  width: 100%;
  height: 160px;
`;

export const VideoThumbnailWrapperMobile = styled.div`
  width: 100%;
  position: relative;
  height: 143px;
  max-height: 143px;
  & video {
    object-fit: cover;
  }
`;
export const PlayIconWrapperMobile = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;
export const MobileVideoWrapper = styled.div<{
  isFullScreen?: boolean;
}>`
  position: relative;
  width: 100%;
  height: fit-content;
  max-height: 450px;
  top: ${({ isFullScreen }) => (isFullScreen ? '40%' : 'unset')};
  transform: ${({ isFullScreen }) =>
    isFullScreen ? 'translateY(-50%)' : 'unset'};
`;
